import React, { useState, useEffect, useMemo } from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { fetchAllPages } from "../../common/tableData";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Dummy from "../../assets/images/No_Image_Available.jpg";

const DatatableTables = ({ t }) => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getExercisesData = async () => {
    setIsLoading(true);
    try {
      const exercises = await fetchAllPages(
        (page, pageSize) =>
          `exercise/exercises/?page=${page}&page_size=${pageSize}`
      );
      setRows(exercises);
    } catch (error) {
      console.error("Error fetching exercise data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getExercisesData();
  }, []);

  const handleEdit = (id) => {
    navigate(`/category/edit-exercise/id/${id}`);
  };

  const tableData = useMemo(
    () => ({
      columns: [
        {
          label: t("ID"),
          field: "id",
          sort: "asc",
          width: 100,
        },
        {
          label: t("Image"),
          field: "image",
          sort: "disabled",
          searchable: false,
          width: 100,
        },
        {
          label: t("Exercise Name"),
          field: "exercise_name",
          sort: "asc",
          width: 150,
        },
        {
          label: t("Status"),
          field: "status",
          sort: "asc",
          width: 100,
        },
        {
          label: t("Category"),
          field: "category_name",
          sort: "asc",
          width: 150,
        },
        {
          label: t("Action"),
          field: "edit",
          sort: "disabled",
          searchable: false,
          width: 100,
        },
      ],
      rows: rows.map((exercise) => ({
        id: exercise.id,
        exercise_name: exercise.exercise_name,
        status: exercise.status ? t("Active") : t("Inactive"),
        image: <img src={exercise.image || Dummy} alt="Exercise" width="50" height="50" />,
        category_name: exercise.category_id ? exercise.category_id.name : "N/A",
        edit: <Button color="primary" onClick={() => handleEdit(exercise.id)}>{t("Edit")}</Button>,
      })),
    }),
    [rows, t]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle={t("Home")} title={t("Data")} breadcrumbItem={t("Exercises")} />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <CardTitle className="h4">{t("Exercises")}</CardTitle>
                    <Button color="primary" onClick={() => navigate(`/category/create-exercise/id/${"id"}`)}>
                      <i className="typcn typcn-plus"></i> {t("Add New Exercise")}
                    </Button>
                  </div>

                  <MDBDataTable
                    responsive
                    striped
                    bordered
                    paging
                    searching
                    sortable
                    order={["id", "asc"]}
                    entries={10}
                    entriesOptions={[10, 25, 50, 100]}
                    displayEntries
                    info
                    infoLabel={[t("Showing"), t("to"), t("of"), t("entries")]}
                    paginationLabel={["<", ">"]}
                    searchLabel={t("Search")}
                    noRecordsFoundLabel={t(isLoading ? "Loading..." : "No records found")}
                    data={tableData}
                    className="custom-cursor-pointer"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(DatatableTables);
